module.exports = __webpack_public_path__ + "static/media/plus-hexagon.12e9cc8e.svg";